export default "__VITE_ASSET__OOdlD_JG__"